import { useQuasar } from 'quasar';
import ConfirmDialog from 'SharedDir/components/base/ConfirmDialog.vue';

type ModalSize = 'extra-small' | 'small' | 'middle' | 'large' | 'extra-large';

type ExtendedQDialogOptions = {
  title?: string;
  message?: string;
  cancelLabel?: string;
  confirmLabel?: string;
  cancel?: boolean;
  persistent?: boolean;
  reverseBtn?: boolean;
  sizeSmall?: boolean;
  size?: ModalSize;
};

/**
 * Обвязка над окном подтверждения
 * В качестве опций почти всегда будет передаваться message, т.к. вряд ли кому то нужно стандартное поведение
 * Вторым аргументом передаётся вызываемая функция, которая сработает, когда пользователь подтвердит действие
 * Третьим аргументом, когда отклонит действие
 *
 * @returns
 */
export const useConfirmationDialog = () => {
  const q = useQuasar();

  const withConfirmation = (
    options: ExtendedQDialogOptions,
    confirmedAction?: any,
    cancelledAction?: () => void
  ) => {
    const dialog = q.dialog({
      component: ConfirmDialog,
      componentProps: {
        message: 'Вы действительно хотите выполнить?',
        ...options,
      },
    });

    if (confirmedAction) {
      dialog.onOk(confirmedAction);
    }
    if (cancelledAction) {
      dialog.onCancel(cancelledAction);
    }
  };

  return {
    withConfirmation,
  };
};
